import {IS_STAGING} from "../../../config";

export const LayoutType = {
  Layout1: 1,
  Layout2: 2,
  Layout3: 3,
  Layout4: 4,
  Layout5: 5,
  Layout6: 6,
};

export const LayoutAbbreviation = {
  All: "ALL",
  Layout1: "Layout1",
  Layout2: "Layout2",
  Layout3: "Layout3",
  Layout4: "Layout4",
  Layout5: "Layout5",
  Layout6: "Layout6",
};

export const LayoutAbbreviations = [
  "Layout1",
  "Layout2",
  "Layout3",
  "Layout4",
  "Layout5",
  "Layout6",
];
export const LayoutAbbreviationsToRemove = [
  "Layout6",
  "Layout5",
  "Layout4",
  "Layout3",
  "Layout2",
  "Layout1",
];

export const METADATA = {
  ALL: "ALL",
  sinkUTypes: ["U", "ST", "FM", "SM"],
  FloorWithIsland: "default",
  NO: "NO",
};

export const PLACEMENTS = {
  Island: "Island",
  Countertop: "Countertop"
};

export const KVSCENE_BACKSPLASH__ENCORE_TYPES = ["4 inch", "6 inch", "8 inch", "Full", "FullWall", "No Backsplash"];
export const KVSCENE_BACKSPLASH_TYPES = ["4 inch", "6 inch", "8 inch", "Full", "No Backsplash"];

export const DECORS_MAX = 25;

const oldKitchenCabinetsLogicProfiles = [
  "americasdream",
  "stonely_inc",
  "215mercury",
  "sci_surfaces",
  "lakeside_surfaces_",
  "true_blue_surfaces_",
  "bellezza_surfaces",
  "premier_cabinet_paintin_llc",
  "premier_cabinet_paintin_llc_v5",
  "american_kitchen_and_stone",
  "arizona_granite",
  "a_granito_world",
  "stonecraft",
  "wallstone_cabinetry_countertops",
  "jg_countertops_llc",
  "the_granite_guys",
  "blue_line_construction",
  "blue_line_construction_2023",
  "williams_kitchen_bath",
  "xpresbathshower",
  "eastern_surfaces",
  "wallstone_cabinetry_countertops_rebuild",
  "the_granite_guys_rebuild",
  "south_florida_remodelers",
  "artemisa",
  "kitchen_doctors_kbf",
  "home_essentials",
  "amc_building_supply_v5",
  "amc_countertops_v5",
  "cafe_countertops",
  "gmd_surfaces",
  "colonial_bath",
  "carpetmart",
];

export const hasOldCabinetLogic = () => {
  if (!window.location.host || (typeof window.location.host !== "string")) {
    return false
  }
  if (document.kvConfig.userId === 246030) {
    return true
  }
  const subDomain = window.location.host.split('.')[0];
  if (IS_STAGING) {
    return subDomain === "moderno_demo_3011" || subDomain === "erpizo" || subDomain === "multitool"
  }
  const url = new URL(window.location.href);
  const params = new URLSearchParams(decodeURIComponent(url.search || "").replace(/amp;/gi, ""));
  return subDomain.includes("porcelanosa_") || window.location.href.includes("fab_subdomain=porcelanosa_")
    || oldKitchenCabinetsLogicProfiles.some(profile => {
      return (profile === subDomain) || (params.get('fab_subdomain') === profile)
      // sci_surfaces should match, but sci_surfaces_v5 - not
    })
}

export const useOldCabinetLogic = hasOldCabinetLogic();
